import axios from '@/libs/api.request'
import fileAxios from '@/libs/file.request'

// 赛事列表
export const apiCompetitionsList = data => {
  return axios.request({
    url: '/admin/competitions',
    method: 'get',
    data,
  })
}
// 赛事详情
export const apiCompetitionsDetail = (id,data) => {
  return axios.request({
    url: `/admin/competitions/${id}`,
    method: 'get',
    data,
  })
}
// 新增赛事
export const apiCompetitionsAdd = data => {
  return axios.request({
    url: '/admin/competitions',
    method: 'post',
    data,
  })
}
// 编辑赛事
export const apiCompetitionsEdit = (id,data) => {
  return axios.request({
    url: `/admin/competitions/${id}`,
    method: 'put',
    data,
  })
}
// 删除赛事
export const apiCompetitionsDetele = (id,data) => {
  return axios.request({
    url: `/admin/competitions/${id}`,
    method: 'delete',
    data,
  })
}

// 报名列表
export const apiCompetitionsSignList = (data) => {
  return axios.request({
    url: `/admin/competitions-registrations`,
    method: 'get',
    data,
  })
}
// 报名详情
export const apiCompetitionsSignDetail = (id,data) => {
  return axios.request({
    url: `/admin/competitions-registrations/${id}`,
    method: 'get',
    data,
  })
}
// 修改报名
export const apiCompetitionsSignEdit = (id,data) => {
  return axios.request({
    url: `/admin/competitions-registrations/${id}`,
    method: 'put',
    data,
  })
}
// 更新赛事名单
export const apiCompetitionsSignUpdate = (id,data) => {
  return axios.request({
    url: `/admin/competitions-registrations/update-list-url/${id}`,
    method: 'put',
    data,
  })
}

// 下载单个报名
export const apiCompetitionsSignExportSingle = (id,data) => {
  return fileAxios.request({
    url: `/admin/competitions-registrations/export-single/${id}`,
    method: 'get',
    data,
  })
}

// 下载全部报名
export const apiCompetitionsSignExportAllTest = (id,data) => {
  return axios.request({
    url: `/admin/competitions-registrations/export-zpi/${id}`,
    method: 'get',
    data,
    type:'file'
  })
}
// 下载全部报名
export const apiCompetitionsSignExportAll = (id,data) => {
  return fileAxios.request({
    url: `/admin/competitions-registrations/export-zpi/${id}`,
    method: 'get',
    data,
  })
}
// 审核
export const apiCompetitionsExamine = (id,data) => {
  return axios.request({
    url: `/admin/competitions-registrations/examine/${id}`,
    method: 'put',
    data,
  })
}